var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _c(
        "HqDrawer",
        {
          ref: "drawer",
          attrs: {
            title:
              _vm.status == "add"
                ? "新增"
                : _vm.status == "detail"
                ? "查看详情"
                : "编辑",
            visible: _vm.drawerVisible,
            size: "70%"
          },
          on: {
            "update:visible": function($event) {
              _vm.drawerVisible = $event
            },
            "on-cancel": _vm.cancel
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "pageform",
              staticStyle: {
                width: "90%",
                margin: "0 auto",
                padding: "12px 0 100px 0"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, rules: _vm.addruleValidate }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "section_title" }, [
                          _vm._v("学员信息")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "orderNo" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "学员订单号",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.orderNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "orderNo", $$v)
                                  },
                                  expression: "form.orderNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "studentName" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "学员姓名",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  readonly: "",
                                  "suffix-icon": "el-icon-search",
                                  disabled: _vm.status != "add"
                                },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.onOpenChoiceStudent.apply(
                                      null,
                                      arguments
                                    )
                                  }
                                },
                                model: {
                                  value: _vm.form.studentName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "studentName", $$v)
                                  },
                                  expression: "form.studentName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("StudentOrder", {
                        ref: "studentOrderModalRef",
                        attrs: { visible: _vm.showStudentOrderModal },
                        on: {
                          "on-ok": _vm.onGoodsDrawerOk,
                          "update:visible": function($event) {
                            _vm.showStudentOrderModal = $event
                          }
                        }
                      }),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "subscribeSchoolName" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "成交校区",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.subscribeSchoolName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "subscribeSchoolName",
                                      $$v
                                    )
                                  },
                                  expression: "form.subscribeSchoolName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "44px" },
                              attrs: { prop: "goodsName" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "报读商品",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.form.goodsName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "goodsName", $$v)
                                  },
                                  expression: "form.goodsName"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c("el-col", { attrs: { span: 24 } }, [
                        _c("p", { staticClass: "section_title" }, [
                          _vm._v("就业确认信息")
                        ])
                      ]),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "interviewPosition" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.jobNameList,
                                  "menu-props": { bottom: true, offsetY: true },
                                  label: "面试职位",
                                  "item-text": "name",
                                  "item-value": "name",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  "clear-icon": "$clear",
                                  "hide-details": "auto",
                                  "no-data-text": "暂无数据",
                                  disabled:
                                    _vm.status == "detail" ||
                                    _vm.status == "passEdit"
                                },
                                on: { change: _vm.changeJobName },
                                model: {
                                  value: _vm.form.interviewPosition,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "interviewPosition", $$v)
                                  },
                                  expression: "form.interviewPosition"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "44px" },
                              attrs: { prop: "employmentCompany" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "就业企业",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled:
                                    _vm.status == "detail" ||
                                    _vm.status == "passEdit"
                                },
                                model: {
                                  value: _vm.form.employmentCompany,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "employmentCompany", $$v)
                                  },
                                  expression: "form.employmentCompany"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticStyle: { "margin-bottom": "44px" },
                              attrs: { prop: "monthlyPay" }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "试用期月薪",
                                  "hide-details": "auto",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  disabled:
                                    _vm.status == "detail" ||
                                    _vm.status == "passEdit"
                                },
                                model: {
                                  value: _vm.form.monthlyPay,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "monthlyPay", $$v)
                                  },
                                  expression: "form.monthlyPay"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "指一个订单的就业次数",
                                placement: "top-start"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "employmentNum" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.employmentNumList,
                                      "menu-props": {
                                        bottom: true,
                                        offsetY: true
                                      },
                                      label: "就业次数",
                                      "item-text": "name",
                                      "item-value": "name",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      "clear-icon": "$clear",
                                      "hide-details": "auto",
                                      "no-data-text": "暂无数据",
                                      disabled:
                                        _vm.status == "detail" ||
                                        (!_vm.historyNoEmploymentTime &&
                                          _vm.status == "passEdit")
                                    },
                                    on: { change: _vm.changeemploymentNum },
                                    model: {
                                      value: _vm.form.employmentNum,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "employmentNum", $$v)
                                      },
                                      expression: "form.employmentNum"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "employmentTime" } },
                            [
                              _c(
                                "v-menu",
                                {
                                  ref: "menu",
                                  attrs: {
                                    "close-on-content-click": false,
                                    "return-value": _vm.form.employmentTime,
                                    transition: "scale-transition",
                                    "offset-y": "",
                                    "min-width": "auto"
                                  },
                                  on: {
                                    "update:returnValue": function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "employmentTime",
                                        $event
                                      )
                                    },
                                    "update:return-value": function($event) {
                                      return _vm.$set(
                                        _vm.form,
                                        "employmentTime",
                                        $event
                                      )
                                    }
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "v-text-field",
                                            _vm._g(
                                              _vm._b(
                                                {
                                                  attrs: {
                                                    label: "学员就业时间",
                                                    "hide-details": "auto",
                                                    outlined: "",
                                                    dense: true,
                                                    height: 32,
                                                    clearable: true,
                                                    readonly: "",
                                                    disabled:
                                                      _vm.status == "detail" ||
                                                      (!_vm.historyNoEmploymentTime &&
                                                        _vm.status ==
                                                          "passEdit")
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.employmentTime,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "employmentTime",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.employmentTime"
                                                  }
                                                },
                                                "v-text-field",
                                                attrs,
                                                false
                                              ),
                                              on
                                            )
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.menu,
                                    callback: function($$v) {
                                      _vm.menu = $$v
                                    },
                                    expression: "menu"
                                  }
                                },
                                [
                                  _c(
                                    "v-date-picker",
                                    {
                                      attrs: {
                                        "no-title": "",
                                        locale: "zh-cn"
                                      },
                                      model: {
                                        value: _vm.form.employmentTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "employmentTime",
                                            $$v
                                          )
                                        },
                                        expression: "form.employmentTime"
                                      }
                                    },
                                    [
                                      _c("v-spacer"),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              _vm.menu = false
                                            }
                                          }
                                        },
                                        [_vm._v("取消")]
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { text: "", color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.$refs.menu.save(
                                                _vm.form.employmentTime
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" 确认 ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "pass" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.passList,
                                  "menu-props": { bottom: true, offsetY: true },
                                  label: "是否转正",
                                  "item-text": "name",
                                  "item-value": "id",
                                  outlined: "",
                                  dense: true,
                                  height: 32,
                                  clearable: true,
                                  "clear-icon": "$clear",
                                  "hide-details": "auto",
                                  "no-data-text": "暂无数据",
                                  disabled: _vm.status == "detail"
                                },
                                on: { change: _vm.changeEmploymentPass },
                                model: {
                                  value: _vm.form.pass,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "pass", $$v)
                                  },
                                  expression: "form.pass"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.form.pass == 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "passTime" } },
                                [
                                  _c(
                                    "v-menu",
                                    {
                                      ref: "turn",
                                      attrs: {
                                        "close-on-content-click": false,
                                        "return-value": _vm.form.passTime,
                                        transition: "scale-transition",
                                        "offset-y": "",
                                        "min-width": "auto"
                                      },
                                      on: {
                                        "update:returnValue": function($event) {
                                          return _vm.$set(
                                            _vm.form,
                                            "passTime",
                                            $event
                                          )
                                        },
                                        "update:return-value": function(
                                          $event
                                        ) {
                                          return _vm.$set(
                                            _vm.form,
                                            "passTime",
                                            $event
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function(ref) {
                                              var on = ref.on
                                              var attrs = ref.attrs
                                              return [
                                                _c(
                                                  "v-text-field",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          label: "转正时间",
                                                          "hide-details":
                                                            "auto",
                                                          outlined: "",
                                                          dense: true,
                                                          height: 32,
                                                          clearable: true,
                                                          readonly: "",
                                                          disabled:
                                                            _vm.status ==
                                                            "detail"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.passTime,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "passTime",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.passTime"
                                                        }
                                                      },
                                                      "v-text-field",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        3792559521
                                      ),
                                      model: {
                                        value: _vm.turn,
                                        callback: function($$v) {
                                          _vm.turn = $$v
                                        },
                                        expression: "turn"
                                      }
                                    },
                                    [
                                      _c(
                                        "v-date-picker",
                                        {
                                          attrs: {
                                            "no-title": "",
                                            locale: "zh-cn"
                                          },
                                          model: {
                                            value: _vm.form.passTime,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "passTime",
                                                $$v
                                              )
                                            },
                                            expression: "form.passTime"
                                          }
                                        },
                                        [
                                          _c("v-spacer"),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  _vm.turn = false
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                text: "",
                                                color: "primary"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.$refs.turn.save(
                                                    _vm.form.passTime
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(" 确认 ")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.form.pass == 1
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "44px" },
                                  attrs: { prop: "passPay" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "转正月薪",
                                      "hide-details": "auto",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      disabled: _vm.status == "detail"
                                    },
                                    model: {
                                      value: _vm.form.passPay,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "passPay", $$v)
                                      },
                                      expression: "form.passPay"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status == "add" || _vm.status == "edit"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "employmentTeacherId" } },
                                [
                                  _c("teacher-select", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return _c("v-autocomplete", {
                                              attrs: {
                                                items: props.teacherData,
                                                "menu-props": {
                                                  bottom: true,
                                                  offsetY: true
                                                },
                                                label: "就业老师",
                                                "item-text": "userName",
                                                "item-value": "userId",
                                                outlined: "",
                                                dense: true,
                                                height: 32,
                                                clearable: true,
                                                "clear-icon": "$clear",
                                                "hide-details": "auto",
                                                "no-data-text": "暂无数据",
                                                disabled:
                                                  _vm.status == "detail" ||
                                                  _vm.status == "passEdit"
                                              },
                                              on: {
                                                change:
                                                  _vm.changeEmploymentTeacher
                                              },
                                              model: {
                                                value:
                                                  _vm.form.employmentTeacherId,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "employmentTeacherId",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.employmentTeacherId"
                                              }
                                            })
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1275169789
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.status == "detail" || _vm.status == "passEdit"
                        ? _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                { attrs: { prop: "employmentTeacher" } },
                                [
                                  _c("teacher-select", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(props) {
                                            return _c("v-autocomplete", {
                                              attrs: {
                                                items: props.teacherData,
                                                "menu-props": {
                                                  bottom: true,
                                                  offsetY: true
                                                },
                                                label: "就业老师",
                                                "item-text": "userName",
                                                "item-value": "userName",
                                                outlined: "",
                                                dense: true,
                                                height: 32,
                                                clearable: true,
                                                "clear-icon": "$clear",
                                                "hide-details": "auto",
                                                "no-data-text": "暂无数据",
                                                disabled:
                                                  _vm.status == "detail" ||
                                                  _vm.status == "passEdit"
                                              },
                                              on: {
                                                change:
                                                  _vm.changeEmploymentTeacher
                                              },
                                              model: {
                                                value:
                                                  _vm.form.employmentTeacher,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "employmentTeacher",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.employmentTeacher"
                                              }
                                            })
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2650447898
                                    )
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { prop: "img" } }, [
                            _c(
                              "div",
                              { staticClass: "upload-box upload-box-daikuan" },
                              [
                                _vm.imgList.length < 8 &&
                                _vm.status !== "detail"
                                  ? _c(
                                      "el-upload",
                                      {
                                        staticClass: "avatar-uploader",
                                        attrs: {
                                          action: _vm.imgUploadDK.host,
                                          "show-file-list": false,
                                          "on-success": _vm.handleAvatarSuccess(),
                                          data: _vm.imgUploadDK,
                                          "before-upload": _vm.beforeAvatarUpload(),
                                          "auto-upload": "",
                                          "http-request": _vm.uploadRequest()
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-plus avatar-uploader-icon"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.imgList.length > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          position: "relative",
                                          display: "flex"
                                        }
                                      },
                                      _vm._l(_vm.imgList, function(
                                        item,
                                        index
                                      ) {
                                        return _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              position: "relative",
                                              "margin-right": "10px"
                                            }
                                          },
                                          [
                                            _c("el-image", {
                                              key: index,
                                              staticClass: "avatar",
                                              staticStyle: {
                                                "object-fit": "contain"
                                              },
                                              attrs: {
                                                src: item,
                                                "preview-src-list": [item]
                                              }
                                            }),
                                            _vm.status !== "detail"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                      "font-size": "20px",
                                                      color: "#fff",
                                                      "line-height": "26px",
                                                      "text-align": "center",
                                                      position: "absolute",
                                                      "border-radius": "13px",
                                                      width: "26px",
                                                      height: "26px",
                                                      right: "-10px",
                                                      top: "-10px",
                                                      "background-color": "red"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.removePic(
                                                          index
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("x")]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "remark" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  outlined: "",
                                  height: 80,
                                  name: "input-7-4",
                                  label: "备注",
                                  value: "",
                                  disabled: _vm.status == "detail"
                                },
                                model: {
                                  value: _vm.form.remark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "remark", $$v)
                                  },
                                  expression: "form.remark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.form.excellentPlan == "1"
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("p", { staticClass: "section_title" }, [
                              _vm._v("陪跑信息")
                            ])
                          ]),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "44px" },
                                  attrs: { prop: "previousSalary" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "陪跑前月薪",
                                      "hide-details": "auto",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      disabled:
                                        _vm.form.signType == "1" ||
                                        _vm.status == "detail" ||
                                        _vm.status == "passEdit"
                                    },
                                    model: {
                                      value: _vm.form.previousSalary,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "previousSalary",
                                          $$v
                                        )
                                      },
                                      expression: "form.previousSalary"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  staticStyle: { "margin-bottom": "44px" },
                                  attrs: { prop: "expectedSalary" }
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "陪跑后月薪",
                                      "hide-details": "auto",
                                      outlined: "",
                                      dense: true,
                                      height: 32,
                                      clearable: true,
                                      disabled:
                                        _vm.form.signType == "1" ||
                                        _vm.status == "detail" ||
                                        _vm.status == "passEdit"
                                    },
                                    model: {
                                      value: _vm.form.expectedSalary,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "expectedSalary",
                                          $$v
                                        )
                                      },
                                      expression: "form.expectedSalary"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                position: "relative",
                                "margin-top": "-18px"
                              },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [_vm._v("就业薪资目标")]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "22px",
                                    "line-height": "50px",
                                    "margin-top": "0px",
                                    "margin-bottom": "30px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "经双方确认，学员在本服务期内的就业薪资目标为：人民币"
                                  )
                                ]
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    left: "375px",
                                    top: "25px"
                                  },
                                  attrs: { span: 12 }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "120px"
                                      },
                                      attrs: { prop: "targetSalary" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "hide-details": "auto",
                                          outlined: "",
                                          dense: true,
                                          height: 32,
                                          clearable: true,
                                          disabled:
                                            _vm.form.signType == "1" ||
                                            _vm.status == "detail" ||
                                            _vm.status == "passEdit"
                                        },
                                        model: {
                                          value: _vm.form.targetSalary,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "targetSalary",
                                              $$v
                                            )
                                          },
                                          expression: "form.targetSalary"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [_vm._v("元/月（税前）。")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: { position: "relative" },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [_vm._v("确认方式")]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    height: "22px",
                                    "line-height": "50px",
                                    "margin-bottom": "30px"
                                  }
                                },
                                [_vm._v("本人现在确认符合以下不退费情形的第")]
                              ),
                              _c(
                                "el-col",
                                {
                                  staticStyle: {
                                    position: "absolute",
                                    left: "250px",
                                    top: "25px",
                                    "vertical-align": "top"
                                  },
                                  attrs: { span: 12 }
                                },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticStyle: {
                                        display: "inline-block",
                                        width: "100px"
                                      },
                                      attrs: { prop: "treaty" }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "hide-details": "auto",
                                          outlined: "",
                                          dense: true,
                                          height: 32,
                                          clearable: true,
                                          disabled:
                                            _vm.form.signType == "1" ||
                                            _vm.status == "detail" ||
                                            _vm.status == "passEdit"
                                        },
                                        model: {
                                          value: _vm.form.treaty,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "treaty", $$v)
                                          },
                                          expression: "form.treaty"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-left": "10px" } },
                                    [_vm._v("条约定，确定协议约定不退费。")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            {
                              staticStyle: {
                                "padding-right": "0",
                                position: "relative"
                              },
                              attrs: { span: 24 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [_vm._v("不退费情形")]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "学员确认，若出现以下任一情形，将不予退费"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "（1）学员在服务期内已达到上述约定的薪资目标；"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "（2）学员因主观原因不参加学习、不完成作业、不配合就业陪跑服务、不参加面试或拒绝就业机会；"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "（3）学员在就业后自愿接受低于约定薪资的工作，并实际到岗就业；"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "（4）学员因个人原因中途放弃就业或退出计划；"
                                  )
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    height: "22px",
                                    "line-height": "50px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "（5）学员提供虚假信息或材料，影响就业推荐或薪资核实。"
                                  )
                                ]
                              ),
                              _vm.status == "detail"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        position: "absolute",
                                        right: "0",
                                        bottom: "0"
                                      }
                                    },
                                    [
                                      _vm.checkSigned === "false"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                                round: "",
                                                loading: _vm.btnLoading
                                              },
                                              on: { click: _vm.qianXieyi }
                                            },
                                            [_vm._v("学员签约")]
                                          )
                                        : _vm._e(),
                                      _vm.checkSigned === "true"
                                        ? _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "primary",
                                                round: "",
                                                loading: _vm.btnLoading
                                              },
                                              on: { click: _vm.signDetail }
                                            },
                                            [_vm._v("查看协议")]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
              _vm.status != "detail"
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.btnLoading },
                      on: { click: _vm.save }
                    },
                    [_vm._v("确认")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              staticClass: "fenqi-xieyi",
              attrs: {
                title: "在线签约学员就业薪资确认单",
                center: "",
                visible: _vm.rsModalVisible,
                width: "620px",
                "append-to-body": true,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
                "show-close": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.rsModalVisible = $event
                }
              }
            },
            [
              _c("div", { staticClass: "modal-wrapper" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-wrapper-post",
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c("div", { ref: "postImg", staticClass: "post-content" }, [
                      _c("div", { staticClass: "post-content-body" }, [
                        _c("div", {
                          staticClass: "goods-img",
                          attrs: { alt: "" }
                        }),
                        _c("div", [
                          _c("p", { staticClass: "goods-name" }, [
                            _vm._v(_vm._s(_vm.form.goodsName))
                          ]),
                          _c("p", { staticClass: "rules" }, [
                            _vm._v(_vm._s(_vm.form.id))
                          ]),
                          _c("p", { staticClass: "stu-name" }, [
                            _c("span", [_vm._v("报名学员")]),
                            _c("span", [_vm._v(_vm._s(_vm.form.studentName))])
                          ])
                        ]),
                        _c("div", { staticClass: "post-content-bottom" }, [
                          _c("div", {
                            ref: "qrcode_heyue",
                            staticClass: "qr-code",
                            attrs: { id: "qrcode_heyue" }
                          }),
                          _c("div", { staticClass: "tips" }, [
                            _c("img", {
                              staticStyle: { "margin-bottom": "6px" },
                              attrs: {
                                src: require("@/assets/image/fingerprint.png"),
                                alt: ""
                              }
                            }),
                            _c("p", [_vm._v("长按识别二维码")]),
                            _c("p", [_vm._v("立即签约《学员")]),
                            _c("p", [_vm._v("就业薪资确认单》")])
                          ])
                        ])
                      ])
                    ])
                  ]
                )
              ]),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.onCloseXieyi }
                    },
                    [_vm._v("关闭")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.btnLoading
                      },
                      on: { click: _vm.getPostImg }
                    },
                    [_vm._v("下载海报")]
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }